export const API_ENDPOINTS = {
  MYREQUEST: {
    FETCH_MYREQUEST_PENDING: `/help-desk/myRequest?ticketStatus=Pending`,
    FETCH_MYREQUEST_COMPLETED: `/help-desk/myRequest?ticketStatus=Completed`,
    REOPEN_REQUEST: (id) => `/help-desk/reopen/${id}`,
    FEEDBACK_SUBMIT: (id) => `/help-desk/feedback/${id}`,
  },
  MYTICKET: {
    FETCH_MYTICKET_PENDING: `/help-desk/myTicket?ticketStatus=Pending`,
    FETCH_MYTICKET_COMPLETED: `/help-desk/myTicket?ticketStatus=Completed`,
    STATUS_CHANGE: (id) => `/help-desk/${id}`,
  },
  MYTEAM: {
    FETCH_MYTEAM_PENDING: `/help-desk/myTeam?ticketStatus=Pending`,
    FETCH_MYTEAM_COMPLETED: `/help-desk/myTeam?ticketStatus=Completed`,
  },
  HELPDESKSPOC: {
    FETCH_MENU_SUBMENU_OPTIONS: (menuId) =>
      menuId ? `/menu/menu-submenu?menuId=${menuId}` : `/menu/menu-submenu`,
    ADD_HELPDESK_SPOC: `/spoc`,
    FETCH_SPOC_LIST: `/spoc/help-desk-master`,
    UPDATE_STATUS_SPOC: (id) => `/spoc/status/${id}`,
    DELETE_SPOC: (id) => `/spoc/${id}`,
    UPDATE_SPOC: (id) => `/spoc/${id}`,
  },
  RAISETICKET: {
    RAISE_TICKET: `/help-desk`,
    MENU_LIST: (menuID) =>
      menuID
        ? `/spoc/help-desk-menus?filterMenuId=${menuID}`
        : `/spoc/help-desk-menus`,
  },
  // /api/help-desk/reports?startDate=07-2020202&endDate=08-29-2222&menu=test1&subMenu=test2&status=pending&sortDirection=DESC&page=0&size=10&search=testsearch
  HRHELPDESKREPORT: {
    FETCH_HRHELPDESK_REPORT: (
      startDate,
      endDate,
      menu,
      subMenu,
      status,
      sortDirection,
      page,
      size,
      bugId
    ) => {
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (menu) queryParams.append("menu", menu);
      if (subMenu) queryParams.append("subMenu", subMenu);
      if (status) queryParams.append("status", status);
      if (sortDirection) queryParams.append("sortDirection", sortDirection);
      if (page) queryParams.append("page", page);
      if (size) queryParams.append("size", size);
      if (bugId) queryParams.append("bugId", bugId);
      return `/help-desk/reports?${queryParams.toString()}`;
    },

    GET_DOWNLOAD_HELP_DESK_EXCEL: (
      startDate,
      endDate,
      menu,
      subMenu,
      status
    ) => {
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (menu) queryParams.append("menu", menu);
      if (subMenu) queryParams.append("subMenu", subMenu);
      if (status) queryParams.append("status", status);
      return `/help-desk/export?${queryParams.toString()}`;
    },
  },

  // /help-desk-report
  // HRHELPDESKREPORT: {
  //   FETCH_HRHELPDESK_REPORT: `/help-desk/reports`,
  // },
  GRAPH: {
    FETCH_GRAPH_DATA: `/help-desk-report/graph`,
  },
  MOVEMENTGRAPH: {
    FETCH_MOVEMENT_GRAPH_DATA: `/help-desk-report/movement-graph`,
  },
};
